import React from "react";

export const Header = () => (
    <span className="ScreenSelect_Header">TAGKAST</span>
);
